import VARIANT from '../inkVariant';
/**
 * Helper function to get default style based on token
 * @param {String} variant
 */
export default function getDefaultInk(variant) {
    switch (variant) {
        case VARIANT.HIGHLIGHT:
            return 'textHighlight';
        case VARIANT.ALERT:
            return 'textAlert';
        case VARIANT.WARNING:
            return 'textWarning';
        case VARIANT.POSITIVE:
            return 'textPositive';
        case VARIANT.PRICE:
            return 'textPrice';
        case VARIANT.PRIMARY:
            return 'textPrimary';
        case VARIANT.SECONDARY:
            return 'textSecondary';
        case VARIANT.MUTED:
            return 'textMuted';
        case VARIANT.PRIMARY_INTERACTIVE:
            return 'textPrimaryInteractive';
        case VARIANT.DESTRUCTIVE_INTERACTIVE:
            return 'textDestructiveInteractive';
        case VARIANT.WHITE:
            return 'textWhite';
        default:
            return 'textPrimary';
    }
}
;
